// Wishlist font family

document.addEventListener("DOMContentLoaded", () => {
  const fontFamily = "var(--primary-font-body-family)";

  const observer = new MutationObserver(() => {
    const productTitles = document.querySelectorAll(
        [
            "wishlist-product-card .wk-category .wk-text-link",
            "wishlist-product-card .wk-product-title .wk-text-link, wishlist-product-card .wk-product-title .wk-text-link:visited",
            ".more-colors"
        ].join(", ")
    );

    if (productTitles.length === 0) return;

    productTitles.forEach((productTitle) => {
      productTitle.style.fontFamily = fontFamily;
    });

    observer.disconnect();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});